export default __webpack_public_path__ + "static/media/rollit.f3b077f4.png";